import { ExtendProps } from 'app';
import { HTMLAttributes, ReactNode, useState } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';

export default function Accordion(
	props: ExtendProps<{ title: ReactNode } & HTMLAttributes<HTMLDivElement>>,
) {
	const [isOpened, toggleIsOpened] = useState(false);
	// max-h-[42px] // max-h-full
	return (
		<div
			className={`accordion cursor-pointer w-full overflow-y-hidden ${props.className}`}
		>
			<div
				className="accordion-title w-full min-h-max flex items-center justify-between p-2"
				onClick={(ev) => toggleIsOpened((prev) => !prev)}
			>
				<span className="font-bold overflow-hidden w-full">{props.title}</span>
				{!isOpened ? <ChevronDown /> : <ChevronUp />}
			</div>

			<div
				className={`${
					!isOpened ? 'max-h-[0px]' : 'max-h-[max-content]'
				} transition-[max-height] ease-linear duration-[600ms] focus-within:max-h-full`}
			>
				{props.children}
			</div>
		</div>
	);
}
